import React from 'react';
export class SidebarErrorBoundary extends React.Component {
    state = { failed: false };
    static getDerivedStateFromError() {
        return { failed: true };
    }
    componentDidCatch(error, reactErrorInfo) {
        this.props.onError({
            boundary: this.props.boundary,
            error,
            ...(reactErrorInfo.componentStack === null
                ? {}
                : { componentStack: reactErrorInfo.componentStack }),
        });
    }
    render() {
        return this.state.failed ? this.props.fallback : this.props.children;
    }
}
//# sourceMappingURL=SidebarErrorBoundary.js.map